import { useTranslation } from "react-i18next";
import BadgeApproved from "../../../../../../../../assets/icons/Badge Approved.svg";
import BadgeError from "../../../../../../../../assets/icons/Badge Error.svg";

const GroupCard = ({ groupName, groupLocation, professorName, groupHasStarted, onEditClick, onAttendanceClick, groupColor, icon, isSubstitute = false, weekDays, groupIsArchived = false }) => {
    const { t } = useTranslation("common");

    return (
        <div className={isSubstitute ? "main-list__card substitute" : "main-list__card"} style={{ position: "relative" }}>
            <div className="main-list__card-image">
                <i className="fa-light fa-user"></i>
                <div className="main-list__card-image-initials" style={{ backgroundColor: groupColor }}>
                    {icon && <img class="groupImg" src={icon} alt="icon" />}
                </div>
            </div>
            <div className="main-list__card-image-badge">{groupHasStarted ? <img src={BadgeApproved} alt="icon" /> : <img src={BadgeError} alt="icon" />}</div>
            <div className="main-list__groupCard-name">{groupName}</div>
            <div className="main-list__groupCard-professor">{weekDays}</div>
            <div className="main-list__groupCard-professor">{t("groups.professor")}: {professorName}</div>
            {/* <div className="main-list__groupCard-location">Lokacija: {groupLocation}</div> */}
            <div
                className={
                    groupIsArchived
                    ? "main-list__groupCard-status--archived"
                    : groupHasStarted
                    ? "main-list__groupCard-status"
                    : "main-list__groupCard-status--notActive"
                }
                >
                Status:{" "}
                {groupIsArchived ? (
                    <span>Archived</span>
                ) : groupHasStarted ? (
                    <span>Active</span>
                ) : (
                    <span>Not Active</span>
                )}
                </div>
            <div className="main-list__card-actions">
                {groupHasStarted ? (
                    <button onClick={onAttendanceClick}>
                        <i className="fa-regular fa-eye"></i>
                        <span>Attendance</span>
                    </button>
                ) : (
                    <button onClick={onEditClick}>
                        <i className="fa-regular fa-pen-to-square"></i>
                        <span>Edit</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default GroupCard;
